import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { API } from "../api";
import { useAuth } from "./AuthContext";

const VendorDataContext = createContext(null);

export const useVendorData = () => useContext(VendorDataContext);

export const VendorDataProvider = ({ children }) => {
  const { user } = useAuth();
  const [businessData, setBusinessData] = useState(null);
  const [liveSession, setLiveSession] = useState(null);
  const [punchSettings, setPunchSettings] = useState(null);
  const [analyticsQuickStats, setAnalyticsQuickStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const isVendor = user?.role === "vendor" || user?.vendor_verified;

  const refreshBusiness = useCallback(async () => {
    if (!isVendor) return;
    try {
      const res = await axios.get(`${API}/vendor/dashboard`);
      const d = res.data;
      setBusinessData(d.business || null);
      setLiveSession({ status: d.session_status, today_location: d.today_location });
      setPunchSettings(d.punch_card || null);
      setAnalyticsQuickStats(d.analytics || null);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }, [isVendor]);

  useEffect(() => {
    if (isVendor) refreshBusiness();
  }, [isVendor, refreshBusiness]);

  if (!isVendor) return children;

  return (
    <VendorDataContext.Provider value={{
      businessData, liveSession, punchSettings, analyticsQuickStats,
      loading, refreshBusiness, setBusinessData, setLiveSession,
    }}>
      {children}
    </VendorDataContext.Provider>
  );
};
